<template>
	<div>
		<div class="image" :style="'background-image: url(' + activity.thumb + ');'" v-if="activity.thumb">
			<img :src="activity.thumb" :alt="activity.name">
		</div>
		<div class="text">
			<h3>
				{{ activity.name }}
				<span class="price" v-if="listing_type=='package_addon'" :style="'--accent: ' +accent">+ {{ activity.formatted_price }}</span>
			</h3>
			<p>{{ nl2br(activity.excerpt) }}</p>
			<template v-if="activity.more_info || activity_options.length > 0 || listing_type == 'package_addon' || listing_type == 'build_your_own'">
				<span class="spacer"></span>
				<div class="buttons">
					<div is="activity-buttons" :type="listing_type" :package_id="package_id" :destination_id="activity.destination.id" :activity_id="activity.id" :options="activity_options" :accent="accent"></div>
					<button v-if="activity.more_info" type="button" class="button medium thin" :data-featherlight="'/ajax/activity-details/'+ activity.id" data-featherlight-after-open="doActivitySlickInPopup()">More Info</button>
				</div>
			</template>
			<p class="small" v-if="listing_type=='package_addon' && activity.price_type=='total'">* based on {{ base_participants }} participants</p>
		</div>
		<div class="sash" v-if="activity.pivot && activity.pivot.sash">{{ activity.pivot.sash }}</div>
	</div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
export default {

	props: {
		activity: {},
		listing_type: {},
		accent: {},
		package_id: {},
		base_participants: {}
	},
	computed: {
		activity_options() {
			var temp = this.activity.repeatables.filter((item) => {
				return (item.repeater_name == 'activity_options')
			});
			return temp;
		}
	},
	methods: {

		nl2br: function (str, is_xhtml) {
			if (typeof str === 'undefined' || str === null) {
				return '';
			}
			var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
			return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
		}
	}
}
</script>